import React, {useContext, useState, useEffect} from 'react';
import ArticlecategoryService from "./ArticlecategoryService";
import {useForm} from "react-hook-form";
import RouterUtils from "../../utils/RouterUtils";
import ErrorText from "../../components/EditForm/ErrorText";
import ValidateUtils from "../../utils/ValidateUtils";
import AppContext from "../../AppContext";

const ArticlecategoryEditForm = props => {
    const context = useContext(AppContext);
    const [model, setModel] = useState({
        id: 0,
        articletype: 10000
    });
    const disabled = false;

    const {register, errors, handleSubmit, reset, formState} = useForm({
        defaultValues: {
            name: '',
            active: true
        }
    });
    const {isDirty, isSubmitting} = formState;

    const onSubmit = data => {
        if (!isDirty) return RouterUtils.goBack(props);

        Object.assign(model, data);
        model.onlyCompanyExposure = model.company > 0;

        return ArticlecategoryService.update(model).then(savedModel => {
            RouterUtils.goBack(props);
        });
    };

    useEffect(() => {
        let id = RouterUtils.getIdFromPath(props, '/articlecategories/:id');
        if (id > 0) {
            Promise.all([
                ArticlecategoryService.findById(id),
            ]).then(values => {
                setModel(values[0]);
                reset(values[0]);
            });
        }
    }, [props, reset])

    return (
        <div className="EditForm">
            <div className="headline">
                <h1>Artikelkategori</h1>
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>

                <div className="ui-dialog-buttonpane p-clearfix button-row">
                    <div className='left-buttons'>
                        {!disabled && <input type='submit' value='Spara' disabled={isSubmitting}/>}
                        <input type='button' value='Avbryt' onClick={e => RouterUtils.goBack(props)}/>
                    </div>
                </div>


                <div className="formItem">
                    <label htmlFor='name'>Namn</label>
                    <input name="name"
                           ref={register({
                               required: ValidateUtils.required(),
                               maxLength: ValidateUtils.maxLength(45)
                           })}
                           style={{width: '350px'}}
                           disabled={disabled}
                    />
                    <ErrorText errors={errors} name="name"/>
                </div>
                <div className="formItem">
                    <label htmlFor='company'>Exponering</label>
                    <select name="company" ref={register()}>
                        <option value={0}>Alla företag</option>
                        <option value={context.currentCompany.id}>Endast {context.currentCompany.name}</option>
                    </select>
                </div>
                <div className="formItem">
                    <label htmlFor='active'>Aktiv</label>
                    <input type='checkbox' name="active" ref={register} disabled={disabled}/>
                </div>
            </form>
        </div>
    );
}

export default ArticlecategoryEditForm;
